import React, {useEffect, useRef, useState} from 'react';
import {chartHeightValues, chartWidthValues} from '@/views/storyboard/utils/chartConstants';
import {BaseModal} from '@/components/modals';
import Button from '@/components/ui/Button';
import i18n from 'i18n';

interface Props {
    width: typeof chartWidthValues[number];
    height: typeof chartHeightValues[number];
    htmlContent: string,
    chartTitle: string,
}

export const CommentContent = React.memo<Props>((
    {
        width,
        height,
        htmlContent,
        chartTitle,
    },
) => {
    const innerContentRef = useRef<HTMLDivElement>(null);

    const [showMoreButtonVisible, setShowMoreButtonVisible] = useState(false);
    const [showMoreModalOpen, setShowMoreModalOpen] = useState(false);

    const offsetHeight = innerContentRef.current?.offsetHeight;

    useEffect(() => {
        if (offsetHeight && offsetHeight > height) {
            setShowMoreButtonVisible(true);
        } else {
            setShowMoreButtonVisible(false);
        }
    }, [
        offsetHeight,
        htmlContent,
        width,
        height,
        setShowMoreButtonVisible,
    ]);

    return (
        <div
            className="px-3 comment-wrapper position-relative overflow-hidden"
            style={{
                width,
                height: height - 16,
            }}
        >
            <div
                ref={innerContentRef}
                 
                dangerouslySetInnerHTML={{__html: htmlContent}}
            />
            {
                showMoreButtonVisible ? (
                    <div className="show-more-gradient position-absolute w-100 pl-3">
                        <Button
                            variant="link"
                            size="sm"
                            className="plain-button position-absolute text-info"
                            onClick={() => setShowMoreModalOpen(true)}
                        >
                            {i18n.t('jt_show_more.text')}
                        </Button>
                    </div>
                ) : null
            }

            <BaseModal
                isOpen={showMoreModalOpen}
                onClose={() => setShowMoreModalOpen(false)}
                title={chartTitle}
            >
                <div
                     
                    dangerouslySetInnerHTML={{__html: htmlContent}}
                />
            </BaseModal>
        </div>
    );
});
